module.exports = __webpack_public_path__ + "media/bootstrap-icons/dash-d4499b1e.svg";